<template>
    <div 
        :class="[
            'flex items-center px-2 bg-gray-100 border border-gray-300 text-gray-500 text-sm h-[34px]',
            position === 'prepend' ? 'border-r-0 rounded-l' : 'border-l-0 rounded-r'
        ]"
    >
        <slot>{{ text }}</slot>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: ''
        },
        position: {
            type: String,
            default: 'prepend',
            validator: (value) => ['prepend', 'append'].includes(value)
        }
    }
}
</script> 